(function () {
    'use strict';

    angular.module('app').controller('HomeController', HomeController);

    HomeController.$inject = [
        '$rootScope',
        '$scope',
        '$location',
        '$timeout',
        '$routeParams',
        '$filter',
        '$http',
        'blockUI',
        'd3Service',
        'TerminalService',
        'BusinessService',
        'StatisticsService',
        'CorporateCustomerService',
        'SelectService',
        '$uibModal',
        'SettingsService'
    ];

    function HomeController(
        $rootScope,
        $scope,
        $location,
        $timeout,
        $routeParams,
        $filter,
        $http,
        blockUI,
        d3Service,
        TerminalService,
        BusinessService,
        StatisticsService,
        CorporateCustomerService,
        SelectService,
        $uibModal,
        SettingsService
    ) {

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getPages = getTotalPaginatedPages;
        $scope.isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com';
        $scope.user = $rootScope.USER;
        $scope.dashboardInfo = $rootScope.BUSINESS_DASHBOARD;
        $scope.isSupportUserExternalId = false;
        $scope.isPhoneValid = isPhoneValid;

        $scope.params = {
            turnover_preset: {
                page: 1,
                count: 50,
                slow_request: true
            },
            visits_preset: {
                page: 1,
                count: 50,
                slow_request: true
            },
            corporate_visits_preset: {
                page: 1,
                count: 50,
                slow_request: true
            },
            corporate_turnover_preset: {
                page: 1,
                count: 50,
                slow_request: true
            },
            loyalty_items_usage_summary: {
                date_from: moment().subtract(1, 'month').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                time_from: moment().startOf('day').utc().toDate(),
                time_to: moment().endOf('day').utc().toDate(),
            },
            statistics_corporate: 'visits',
            redeem_by_pos_preset: {slow_request: true},
            bonuses_preset: {slow_request: true},
            turnover_by_pos_preset: {slow_request: true},
            turnover_by_time_preset: {slow_request: true, level: 'month'},
            visits_by_time_preset: {slow_request: true, level: 'month'},
            visits_by_pos_preset: {slow_request: true, level: 'month'},
            corporate_visits_by_time_preset: {slow_request: true, level: 'month'},
            corporate_visits_by_pos_preset: {slow_request: true, level: 'month'},
            corporate_turnover_by_time_preset: {slow_request: true, level: 'month'},
            corporate_turnover_by_pos_preset: {slow_request: true, level: 'month'},
            segments_dynamics_preset: {slow_request: true, level: 'month'},
            corporate_segments_dynamics_preset: {slow_request: true, level: 'month'},
            using_app_preset: {slow_request: true},
            customer_phone: '',
            customer_email: '',
            customer_external_id: '',
            commercial_customer_email: '',
            commercial_customer_id: ''
        };

        $scope.data = {
            pagerLengths: [10, 20, 50, 100, 200],
            levels: ['year', 'month', 'week', 'day', 'hour', 'month-of-year', 'week-of-year', 'day-of-month', 'day-of-week', 'hour-of-day'],
            levels_turnover_by_time: ['year', 'month', 'week', 'day', 'hour'],
            levels_segments: ['month', 'quarter', 'week'],
            prepared: {
                // redeem_by_pos: [],
                // bonuses: [],
                // turnover_by_pos: []
            },
            customerTypes: [
                {
                    title: "Customer email",
                    value: "email"
                },
                {
                    title: "Customer phone",
                    value: "phone"
                },
            ],
            currentCustomerLoginType: {
                title: "Customer email",
                value: "email"
            },
            demo: {},
            blockers_list: [
                'home',
                'visits',
                'turnover',
                'corporate_visits',
                'redeem_by_pos',
                'bonuses',
                'turnover_by_pos',
                'turnover_by_time',
                'visits_by_time',
                'visits_by_pos',
                'segments_dynamics',
                'corporate_segments_dynamics',
                'loyalty_items_usage_summary',
                'using_app'],
            registersList: [],
            registersGoods: [],
            filtersList: [],
            showDisabledTerminals: false,
            haveGoodsError: false,
        };

        $scope.state = {
            pageMode: 'dashboard',
            currentTab: null,
            showDemo: false,
            tariffInfoReady: false,
            hideLostCustomers: false,
            hideLostCorporateCustomers: false
        };

        $scope.blockers = {};

        $scope.priceTab = 'retail';
        $scope.getLoyaltyList = SelectService.getLPRList;
        $scope.priceAccounts = {};

        var block_terminals_margins = blockUI.instances.get('terminals_margins');
        var terminalsBlocks = [];

        SettingsService.GetPlatformParams(function (success, response) {
            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;
                if ($scope.isSupportUserExternalId) {
                    $scope.data.customerTypes.push({
                        title: "Customer external id",
                        value: "external-id"
                    })
                }
            }
            initController();
        });

        $scope.priceExplainInfo = [];

        $scope.takeMessage = function (id) {
            return $scope.priceExplainInfo.find(function (explain) {
                //if (explain.id === id) {
                return explain.id === id;
                //  }
            });
        };

        var takeMessageBuildCached = {};

        $scope.takeMessageBuild = function (priceInfo, finallyPrice) {
            var key = [
                priceInfo.id,
                priceInfo.type || 'type',
                priceInfo.special_account_id || 'special_account_id',
                priceInfo.special_account ? priceInfo.special_account.corporate : '-'
            ].join('_');

            var messageTemp = [],
                currency = '';

            if (priceInfo.currency) {
                currency = priceInfo.currency;
            }

            if (priceInfo.special_account && priceInfo.special_account.currency) {
                currency = priceInfo.special_account.currency;
            }

            var priceExplain = priceInfo.price_explain;

            if (priceInfo.special_account) {

                if (
                    ($scope.priceTab == 'search-by-commercial' || $scope.priceTab == 'search-by-customer') &&
                    priceInfo.special_account.active &&
                    priceInfo.customer_prices
                ) {
                    var account = priceInfo.customer_prices.find(function (element) {
                        return element.account_id === priceInfo.special_account.id;
                    })

                    if (account) {
                        priceExplain = account.price_explain;
                    }
                }
            }

            build(priceExplain)

            function build(priceExplain) {
                (priceExplain || []).map(function (explain) {
                    if (!!explain.modifier) {
                        (explain.modifier.detailing || []).map(function (detail) {
                            switch (detail.value_type) {
                                case 'amount' : {
                                    if (detail.value_option === "discount") {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + $filter('translate')('price_explain#discount#' + detail.value_type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    if (detail.type === 'base-tax') {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + (detail.exempt ? ' (' + $filter('translate')('Tax exempt') + ')' : '') + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    if (detail.type === 'sales-tax') {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.value_type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + (detail.exempt ? ' (' + $filter('translate')('Tax exempt') + ')' : '') + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    messageTemp.push(
                                        [
                                            '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.value_type),
                                            ': ',
                                            $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + '</span>'
                                        ].join('')
                                    );
                                    break;
                                }
                                case 'percentage' : {

                                    if (detail.value_option === "discount") {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + $filter('translate')('price_explain#discount#' + detail.value_type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    if (detail.type === 'base-tax') {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + (detail.exempt ? ' (' + $filter('translate')('Tax exempt') + ')' : '') + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    if (detail.type === 'sales-tax') {
                                        messageTemp.push(
                                            [
                                                '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.value_type),
                                                ': ',
                                                $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + (detail.exempt ? ' (' + $filter('translate')('Tax exempt') + ')' : '') + '</span>'
                                            ].join('')
                                        );
                                        break;
                                    }

                                    messageTemp.push(
                                        [
                                            '<span class="sublevel"> - ' + (detail.value_title || '') + ' ' + $filter('translate')('price_explain#' + detail.value_type),
                                            ', ',
                                            detail.value_origin + '%',
                                            ': ',
                                            $filter('currencyFormat')(detail.value, currency, explain.decimal_digits || 2) + '</span>'
                                        ].join('')
                                    );

                                    break;
                                }
                                default:
                                    break;
                            }
                        });
                    }
                    messageTemp.push(
                        [
                            '<span class="level-title">' + $filter('translate')('price_explain#type#' + explain.level_type),
                            ': ',
                            $filter('currencyFormat')(explain.value, currency, explain.decimal_digits || 2) + '</span>'
                        ].join('')
                    );
                });
            }


            messageTemp.push(
                [
                    '<span class="total-title">' + $filter('translate')('price_explain#total'),
                    ': ',
                    $filter('currencyFormat')(finallyPrice, currency, (priceInfo.price_decimal_digits || 2)) + '</span>'
                ].join('')
            );
            return takeMessageBuildCached[key] = messageTemp.join('\n');
        };

        $scope.isActiveTooltip = [];

        $scope.hideAllTooltips = function () {
            if ($scope.isActiveTooltip[$scope.priceTab]) {
                $scope.isActiveTooltip[$scope.priceTab] = [];
            }
        };

        function initController() {
            initPageMode();
            initBlockers();
            initFilters();
            getCurrenciesList();
            getDashboard();

            function s() {
                if ($rootScope.ENV.business.currency && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.settings.hideDemo)
                        $scope.state.showDemo = false;
                    else
                        $scope.state.showDemo = moment().diff(moment($rootScope.ENV.business.created), 'days', true) <= 14;

                    if ($rootScope.ENV.business.tariff.analytics_available) {
                        $rootScope.TARIFF_LIMITATION.analytics_available = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.analytics_available = true;
                    }

                    getDemoData();
                } else {
                    $timeout(s, 250);
                }
            }

            if (!isPageMode('dashboard')) {
                s();
            }
        }

        $scope.onChangePriceTab = function (tabName) {
            $scope.priceTab = tabName;
            $scope.data.registersList = [];
            block_terminals_margins.stop();
            if ($scope.priceTab !== 'search-by-commercial' && $scope.priceTab !== 'search-by-customer') {
                // getTerminals();
            }
        };

        $scope.getTerminals = getTerminals;

        function getTerminals() {
            block_terminals_margins.start();
            $scope.data.haveGoodsError = false;
            $scope.data.registersGoods = [];
            TerminalService.All(function (success, response) {
                if (!success) {
                    block_terminals_margins.stop();
                    return
                }
                if (success) {
                    $scope.data.registersList = $rootScope.TERMINALS
                    var terminals = $rootScope.TERMINALS
                    var filteredTerminals = [];


                    if ($scope.data.currentFilter) {
                        if ($scope.data.currentFilter.filter_list_type === "all") {
                            filteredTerminals = terminals;
                        } else {
                            terminals.forEach(function (t) {
                                if ($scope.data.currentFilter.filter_list_type === 'loyalty' && $scope.data.currentFilter.id == t.loyalty_id)
                                    filteredTerminals.push(t)

                                if ($scope.data.currentFilter.filter_list_type === 'register' && $scope.data.currentFilter.id == t.id)
                                    filteredTerminals.push(t)

                                if ($scope.data.currentFilter.filter_list_type === 'pos' && $scope.data.currentFilter.id == t.pos_id)
                                    filteredTerminals.push(t)
                            })
                        }
                        $scope.data.registersList = filteredTerminals;
                    }


                    if ($scope.data.registersList.length > 0) {
                        getTerminalGoods($scope.data.registersList[0], 0);
                    }

                    if ($scope.data.registersList.length === 0) {
                        block_terminals_margins.stop();
                    }
                }
            });
        }


        function getTerminalGoods(terminal, terminalIndex) {

            if ($scope.data.haveGoodsError) {
                $scope.data.registersList = [];
                $scope.data.registersGoods = [];
                return;
            }

            var params = {
                category: 'all',
                count: 300,
                service_type: 'fuel'
            }

            if ($scope.priceTab == 'search-by-customer') {

                if ($scope.data.currentCustomerLoginType.value == 'phone') {
                    params.user_id_value = $scope.params.customer_phone;
                }

                if ($scope.data.currentCustomerLoginType.value == 'email') {
                    params.user_id_value = $scope.params.customer_email;
                }

                if ($scope.data.currentCustomerLoginType.value == 'external-id') {
                    params.user_id_value = $scope.params.customer_external_id;
                }
                params.user_id_type = $scope.data.currentCustomerLoginType.value;
            }

            if ($scope.priceTab == 'search-by-commercial') {
                params.corporate_customer_id = $scope.params.commercial_customer_id;
            }

            params.customers_account_info = true;

            TerminalService.GetTerminalGoods(params, terminal.id, function (success, goods) {

                if (!success) {
                    block_terminals_margins.stop();
                    $scope.data.registersList = [];
                    $scope.data.haveGoodsError = true;
                }

                if (success) {
                    terminal.priceAccounts = {};
                    goods.forEach(function (good) {
                        good.retailPrices = {};
                        good.personalAccountPrices = {};
                        good.corporateAccountPrices = {};

                        function handleCustomerPrices(prices) {
                            prices.forEach(function (price) {
                                var id = price.customer_account_id || price.id;
                                if (price.type !== 'currency') {
                                    terminal.priceAccounts[id] =
                                        {
                                            account_title: price.special_account.public_title,
                                            sub_title: '',
                                            corporate: price.special_account.corporate,
                                            currency: 0,
                                            price_decimal_digits: price.price_decimal_digits,
                                            type: price.special_account.type
                                        };

                                    if (!!price.special_account) {
                                        if (!!price.special_account.corporate) {
                                            // Цена для корпоративного счета
                                            terminal.priceAccounts[id].sub_title = price.customer_account.corporate_customer.name;
                                            good.corporateAccountPrices[id] = price;
                                        } else {
                                            terminal.priceAccounts[id].sub_title = price.customer_account.retail_customer.user.name;
                                            good.personalAccountPrices[id] = price;
                                        }
                                    }
                                }

                                if (price.type === 'currency') {
                                    var id = price.currency || price.id,
                                        title = price.currency || price.id;
                                    terminal.priceAccounts[id] =
                                        {
                                            account_title: title,
                                            corporate: 0,
                                            currency: 1,
                                            price_decimal_digits: price.price_decimal_digits,
                                            type: price.type
                                        };

                                    good.retailPrices[id] = price;
                                }
                            });
                        }

                        good.price.forEach(function (price) {

                            if (price.customer_prices) {
                                handleCustomerPrices(price.customer_prices);
                                return;
                            }

                            if (price.type === 'special-account') {
                                terminal.priceAccounts[price.special_account_id] =
                                    {
                                        account_title: price.special_account.public_title,
                                        corporate: price.special_account.corporate,
                                        currency: 0,
                                        price_decimal_digits: price.price_decimal_digits,
                                        type: price.special_account.type
                                    };

                                if (!!price.special_account) {
                                    if (!!price.special_account.corporate) {
                                        // Цена для корпоративного счета
                                        good.corporateAccountPrices[price.special_account_id] = price;
                                    } else {
                                        good.personalAccountPrices[price.special_account_id] = price;
                                    }
                                }
                            }

                            if (price.type === 'currency') {
                                var id = price.currency || price.id,
                                    title = price.currency || price.id;
                                terminal.priceAccounts[id] =
                                    {
                                        account_title: title,
                                        corporate: 0,
                                        currency: 1,
                                        price_decimal_digits: price.price_decimal_digits,
                                        type: price.type
                                    };

                                good.retailPrices[id] = price;
                            }
                        });
                    });


                    terminal.priceAccountsIds = Object.keys(terminal.priceAccounts);
                    $scope.data.registersGoods.push(goods);
                }
                // if (terminalIndex < 4 && $scope.data.registersList[terminalIndex + 1] ) {
                if (!$scope.data.haveGoodsError && $scope.data.registersList[terminalIndex + 1]) {
                    getTerminalGoods($scope.data.registersList[terminalIndex + 1], terminalIndex + 1);
                }
                // terminalsBlocks[terminalIndex].stop();
                if ($scope.data.registersList.length == terminalIndex + 1) {
                    block_terminals_margins.stop();
                }
            });
            // $scope.showHideExpensesMarkups();
        }

        $scope.goToCosts = function (terminal) {
            $location.path('/terminals/edit/' + terminal.id + '?tab=additionalCosts');
        };

        $scope.isPageMode = isPageMode;

        function isPageMode(mode) {
            return mode == $scope.state.pageMode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            console.info('home initPageMode', $routeParams);
            $scope.state.pageMode = 'dashboard';
            $scope.state.currentTab = null;
            if ($routeParams['tab']) {
                $scope.state.pageMode = 'analytics';
                switch ($routeParams['tab']) {
                    case 'cost_mark-ups':
                        // getTerminals();
                        break;
                }
            }

            if ($scope.state.pageMode == 'analytics') {
                initTabs();
            }
        }

        function initTabs() {
            console.info('home initTabs', $routeParams);
            if ($routeParams['tab']) {
                $scope.state.currentTab = $routeParams['tab'];
            } else {
                $scope.state.currentTab = 'customers';
            }
        }

        function initFilters() {
            $scope.blockers.home.start();

            for (var i in $scope.params) {
                if (i.indexOf('_preset') !== -1) {
                    if (['visits_by_time', 'visits_by_pos', 'turnover_by_time', 'segments_dynamics', 'corporate_segments_dynamics'].indexOf(i.substring(0, i.indexOf('_preset'))) !==
                        -1)
                        $scope.params[i].period_begin = moment().subtract(3, 'month').utc().toDate();
                    else
                        $scope.params[i].period_begin = moment().subtract(1, 'month').utc().toDate();

                    $scope.params[i].period_end = moment().endOf('day').utc().toDate();

                    $scope.params[i.substring(0, i.indexOf('_preset'))] = angular.copy($scope.params[i]);
                }
            }
        }

        function initBlockers() {
            var bl = $scope.data.blockers_list;
            for (var i in bl)
                $scope.blockers[bl[i]] = blockUI.instances.get(bl[i]);
        }

        function getDemoData() {
            $http.get('demo-data.json?v=1').then(function (result) {
                console.info('demo data loaded: ', result.data);
                $scope.data.demo = result.data;

                d3Service.d3().then(function (d3) {
                    for (var i in $scope.data.demo.turnover_by_time)
                        for (var k in $scope.data.demo.turnover_by_time[i]) {
                            if (k !== 'date' && $scope.data.demo.turnover_by_time_fields.indexOf(k) === -1)
                                $scope.data.demo.turnover_by_time_fields.push(k);
                        }

                    for (var i in $scope.data.demo.turnover_by_time_fields) {
                        var t = $scope.data.demo.turnover_by_time_fields[i];
                        $scope.data.demo.turnover_by_time_fields_colors[t] = d3.interpolateRainbow(i / $scope.data.demo.turnover_by_time_fields.length);
                    }
                });

            });
        }

        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0)
                BusinessService.CurrencyList(null, function (success, response) {
                    if (success) {
                        $scope.data.currenciesList = response;
                    }
                });
        }

        function getDashboard() {
            BusinessService.Dashboard(function (success, response) {
                if (success) {
                    $rootScope.BUSINESS_DASHBOARD = response;
                }
                $scope.blockers.home.stop();
            });
        }

        function getVisits() {
            // if (!$scope.blockers.visits.state().blocking)
            $scope.blockers.visits.start();

            var params = angular.copy($scope.params.visits);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.TopVisits(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.visits = [];

                    for (var i in $rootScope.STATISTICS.visits.data) {
                        // var t = $rootScope.STATISTICS.visits.data[i];
                        // $scope.data.prepared.visits.push({title: t.user_phone || '', value: t.visits || 0 })
                        var t = $rootScope.STATISTICS.visits.data[i];
                        if (t.visits > 0)
                            $scope.data.prepared.visits.push({
                                title: t.user_email || t.user_phone || t.user_external_id || '',
                                value: t.visits || 0
                            });
                    }
                }

                // saveJSONToFile('visits', $scope.data.prepared.visits);

                $scope.blockers.visits.stop();
            });
        }

        function getCorporateVisits() {
            // if (!$scope.blockers.visits.state().blocking)
            $scope.blockers.corporate_visits.start();

            var params = angular.copy($scope.params.corporate_visits);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.CorporateTopVisits(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.corporate_visits = [];

                    for (var i in $rootScope.STATISTICS.corporate_visits.data) {
                        // var t = $rootScope.STATISTICS.visits.data[i];
                        // $scope.data.prepared.visits.push({title: t.user_phone || '', value: t.visits || 0 })
                        var t = $rootScope.STATISTICS.corporate_visits.data[i];
                        if (t.visits > 0)
                            $scope.data.prepared.corporate_visits.push({
                                title: t.corporate_customer_name || t.corporate_customer_company_name || t.corporate_customer_id || '',
                                value: t.visits || 0
                            });
                    }
                }

                // saveJSONToFile('visits', $scope.data.prepared.visits);

                $scope.blockers.corporate_visits.stop();
            });
        }

        function getTurnover() {
            // if (!$scope.blockers.turnover.state().blocking)
            $scope.blockers.turnover.start();

            if (!$scope.params.turnover.currency)
                $scope.params.turnover.currency = $rootScope.ENV.business.currency;

            var params = angular.copy($scope.params.turnover);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.TopTurnover(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.turnover = [];
                    for (var i in $rootScope.STATISTICS.turnover.data) {
                        // var t = $rootScope.STATISTICS.turnover.data[i];
                        // $scope.data.prepared.turnover.push({title: t.user_phone || '', value: t.amount || 0 })
                        var t = $rootScope.STATISTICS.turnover.data[i];
                        if (t.amount > 0)
                            $scope.data.prepared.turnover.push({
                                title: t.user_email || t.user_phone || t.user_external_id || '',
                                value: t.amount || 0
                            });
                    }
                }

                // saveJSONToFile('turnover', $scope.data.prepared.turnover);

                $scope.blockers.turnover.stop();
            });
        }


        function getCorporateTurnover() {
            // if (!$scope.blockers.turnover.state().blocking)
            $scope.blockers.corporate_visits.start();

            var params = angular.copy($scope.params.corporate_visits);

            if (!$scope.params.corporate_turnover.currency)
                params.currency = $rootScope.ENV.business.currency;

            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.CorporateTopTurnover(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.corporate_turnover = [];
                    for (var i in $rootScope.STATISTICS.corporate_turnover.data) {
                        // var t = $rootScope.STATISTICS.turnover.data[i];
                        // $scope.data.prepared.turnover.push({title: t.user_phone || '', value: t.amount || 0 })
                        var t = $rootScope.STATISTICS.corporate_turnover.data[i];
                        if (t.amount > 0)
                            $scope.data.prepared.corporate_turnover.push({
                                title: t.corporate_customer_name || t.corporate_customer_company_name || t.corporate_customer_id || '',
                                value: t.amount || 0
                            });
                    }
                }

                $scope.blockers.corporate_visits.stop();
            });
        }


        function getRedeemByPOS() {
            // if (!$scope.blockers.redeem_by_pos.state().blocking)
            $scope.blockers.redeem_by_pos.start();

            if (!$scope.params.redeem_by_pos.currency)
                $scope.params.redeem_by_pos.currency = $rootScope.ENV.business.currency;

            var params = angular.copy($scope.params.redeem_by_pos);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            if (!params.pos_id)
                delete params.pos_id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.RedeemByPOS(params, function (success, response) {
                if (success) {
                    if (response.data.length > 0) {
                        $scope.data.prepared.redeem_by_pos = [
                            {field: 'to_pay_amount', value: 0, color: 'rgb(97,181,97)'},
                            {field: 'bonuses_redeemed_amount', value: 0, color: 'rgb(233,108,62)'},
                            {field: 'discount_amount', value: 0, color: 'rgb(233,158,38)'}
                        ];

                        for (var i in response.data) {
                            $scope.data.prepared.redeem_by_pos[0].value += response.data[i].to_pay_amount;
                            $scope.data.prepared.redeem_by_pos[1].value += response.data[i].bonuses_redeemed_amount;
                            $scope.data.prepared.redeem_by_pos[2].value += response.data[i].discount_amount;
                        }

                        // saveJSONToFile('redeem_by_pos', $scope.data.prepared.redeem_by_pos);
                    } else {
                        $scope.data.prepared.redeem_by_pos = [
                            {
                                field: 'no_data',
                                value: 100,
                                color: 'rgb(225,225,225)'
                            }];
                    }
                }
                $scope.blockers.redeem_by_pos.stop();
            });
        }

        function getBonuses() {
            // if (!$scope.blockers.bonuses.state().blocking)
            $scope.blockers.bonuses.start();

            if (!$scope.params.bonuses.currency)
                $scope.params.bonuses.currency = $rootScope.ENV.business.currency;

            var params = angular.copy($scope.params.bonuses);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.Bonuses(params, function (success, response) {
                if (success) {

                    if (response.data[0]) {
                        $scope.data.prepared.bonuses_on_hand_amount = response.data[0].bonuses_on_hand_amount;
                        var e = response.data[0].bonuses_earned_amount,
                            r = response.data[0].bonuses_redeemed_amount;

                        $scope.data.prepared.bonuses = [
                            // {field: 'bonuses_on_hand_amount',   value: response.data[0].bonuses_on_hand_amount },
                            {
                                field: 'bonuses_earned_amount',
                                value: e > r ? e - r : 0,
                                d_value: e,
                                color: 'rgb(225,225,225)'
                            },
                            {
                                field: 'bonuses_redeemed_amount_b',
                                value: r,
                                d_value: r,
                                color: 'rgb(29,120,250)'
                            }
                        ];

                        // saveJSONToFile('bonuses', $scope.data.prepared.bonuses);
                    } else {
                        $scope.data.prepared.bonuses = [{field: 'no_data', value: 100, color: 'rgb(225,225,225)'}];
                    }
                }
                $scope.blockers.bonuses.stop();
            });
        }

        function getTurnoverByPOS() {
            // if (!$scope.blockers.turnover_by_pos.state().blocking)
            $scope.blockers.turnover_by_pos.start();

            if (!$scope.params.turnover_by_pos.currency)
                $scope.params.turnover_by_pos.currency = $rootScope.ENV.business.currency;

            var params = angular.copy($scope.params.turnover_by_pos);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            if (!params.pos_id)
                delete params.pos_id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.TurnoverByPOS(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.turnover_by_pos = [];

                    if (response.data.length > 0)
                        d3Service.d3().then(function (d3) {
                            for (var i in response.data)
                                $scope.data.prepared.turnover_by_pos.push({
                                    field: response.data[i].pos_id,
                                    value: response.data[i].amount,
                                    percentage: response.data[i].percentage,
                                    color: d3.interpolateRainbow(response.data[i].amount / 100)
                                });
                        });
                    else
                        $scope.data.prepared.turnover_by_pos = [
                            {
                                field: 'no_data',
                                value: 100,
                                color: 'rgb(225,225,225)'
                            }];

                }
                $scope.blockers.turnover_by_pos.stop();
            });
        }

        function getTurnoverByTime() {
            $scope.blockers.turnover_by_time.start();

            if (!$scope.params.turnover_by_time.currency)
                $scope.params.turnover_by_time.currency = $rootScope.ENV.business.currency;

            var params = angular.copy($scope.params.turnover_by_time),
                get_total = (params.pos_id === 'total') ? true : false;

            params.loyalty_id = $scope.data.currentLoyalty.id;

            if (!params.pos_id || params.pos_id === 'total')
                delete params.pos_id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.TurnoverByTime(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.turnover_by_time = [];
                    $scope.data.prepared.turnover_by_time_fields = [];
                    $scope.data.prepared.turnover_by_time_fields_colors = [];

                    d3Service.d3().then(function (d3) {
                        for (var i in response.data) {
                            $scope.data.prepared.turnover_by_time_fields.push(i);
                            // $scope.data.prepared.turnover_by_time_fields_colors

                            for (var k in response.data[i]) {
                                var item = {date: response.data[i][k].time_interval};
                                item[i] = response.data[i][k].amount;

                                if ($scope.data.prepared.turnover_by_time[k])
                                    $scope.data.prepared.turnover_by_time[k][i] = response.data[i][k].amount || 0;
                                else
                                    $scope.data.prepared.turnover_by_time[k] = item;
                            }
                        }

                        if (get_total) {
                            var data = $scope.data.prepared.turnover_by_time;

                            for (var i in data) {
                                if (!data[i].total)
                                    data[i].total = 0;

                                for (var k in data[i])
                                    if (k !== 'date' && k !== 'width' && k !== 'total' && parseFloat(data[i][k]) !== NaN) {
                                        data[i].total += data[i][k];
                                        delete (data[i][k]);
                                    }
                            }

                            $scope.data.prepared.turnover_by_time_fields = ['total'];
                            $scope.data.prepared.turnover_by_time = data;
                        }

                        // saveJSONToFile('turnover_by_time', $scope.data.prepared.turnover_by_time);

                        if ($scope.data.prepared.turnover_by_time.length < 2)
                            $scope.data.prepared.turnover_by_time = null;

                        for (var i in $scope.data.prepared.turnover_by_time_fields) {
                            var t = $scope.data.prepared.turnover_by_time_fields[i];
                            $scope.data.prepared.turnover_by_time_fields_colors[t] = d3.interpolateRainbow(
                                i / $scope.data.prepared.turnover_by_time_fields.length);
                        }
                    });
                }
                $scope.blockers.turnover_by_time.stop();
            });
        }

        function getVisitsByPOS() {
            $scope.blockers.visits_by_pos.start();

            var request = StatisticsService.VisitsByPOS,
                params = angular.copy($scope.params.visits_by_pos);

            params.loyalty_id = $scope.data.currentLoyalty.id;

            if (!params.pos_id) {
                request = StatisticsService.VisitsByTime;
                delete params.pos_id;
            }

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            request(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.visits_by_pos = [];

                    var r = params.pos_id ? response.data[params.pos_id] : response.data;
                    for (var i in r) {
                        if (params.level === 'hour-of-day') {
                            var tz_offset = new Date().getTimezoneOffset(),
                                offset = -tz_offset / 60,
                                date = parseInt(r[i].time_interval);

                            $scope.data.prepared.visits_by_pos.push({
                                date: (date + offset > 23) ? (date + offset - 24) : (date + offset),
                                value: r[i].visits
                            });
                        } else {
                            $scope.data.prepared.visits_by_pos.push({date: r[i].time_interval, value: r[i].visits});
                        }
                    }

                    // saveJSONToFile('visits_by_pos', $scope.data.prepared.visits_by_pos);

                    if ($scope.data.prepared.visits_by_pos.length < 2)
                        $scope.data.prepared.visits_by_pos = null;
                }
                $scope.blockers.visits_by_pos.stop();
            });
        }

        function getSegmentsDynamics() {
            // if (!$scope.blockers.segments_dynamics.state().blocking)
            $scope.blockers.segments_dynamics.start();

            var params = angular.copy($scope.params.segments_dynamics);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.SegmentsDynamics(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.segments_dynamics = [];
                    $scope.data.prepared.segments_dynamics_fields = ['customers_new', 'customers_active', 'customers_passive', 'customers_lost'];

                    for (var i in response)
                        $scope.data.prepared.segments_dynamics.push({
                            date: response[i].time_marker,
                            customers_lost: response[i].customers_lost,
                            customers_passive: response[i].customers_passive,
                            customers_active: response[i].customers_active,
                            customers_new: response[i].customers_new
                        });

                    if ($scope.data.prepared.segments_dynamics.length < 2)
                        $scope.data.prepared.segments_dynamics = null;

                    // saveJSONToFile('segments_dynamics', $scope.data.prepared.segments_dynamics);
                }
                $scope.blockers.segments_dynamics.stop();
            });
        }

        function getCorporateSegmentsDynamics() {
            $scope.blockers.corporate_segments_dynamics.start();

            var params = angular.copy($scope.params.corporate_segments_dynamics);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD');

            StatisticsService.CorporateSegmentsDynamics(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.corporate_segments_dynamics = [];
                    $scope.data.prepared.corporate_segments_dynamics_fields = ['customers_new', 'customers_active', 'customers_passive', 'customers_lost'];

                    for (var i in response)
                        $scope.data.prepared.corporate_segments_dynamics.push({
                            date: response[i].time_marker,
                            customers_lost: response[i].customers_lost,
                            customers_passive: response[i].customers_passive,
                            customers_active: response[i].customers_active,
                            customers_new: response[i].customers_new
                        });

                    if ($scope.data.prepared.corporate_segments_dynamics.length < 2)
                        $scope.data.prepared.corporate_segments_dynamics = null;
                }
                $scope.blockers.corporate_segments_dynamics.stop();
            });
        }

        $scope.getLoyaltyItemsUsageTerminalSummary = getLoyaltyItemsUsageTerminalSummary;

        function getLoyaltyItemsUsageTerminalSummary() {
            $scope.blockers.loyalty_items_usage_summary.start();

            var params = angular.copy($scope.params.loyalty_items_usage_summary);

            params.period_begin = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            });
            delete params.date_from;
            delete params.time_from;

            params.period_end = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            });
            delete params.date_to;
            delete params.time_to;


            if ($scope.data.currentFilter.id && $scope.data.currentFilter.filter_list_type === 'loyalty') {
                params.loyalty_id = $scope.data.currentFilter.id;
            }

            if ($scope.data.currentFilter.id && $scope.data.currentFilter.filter_list_type === 'register') {
                params.terminal_id = $scope.data.currentFilter.id;
                params.loyalty_id = $scope.data.currentFilter.loyalty_id;
            }

            if ($scope.data.currentFilter.id && $scope.data.currentFilter.filter_list_type === 'pos') {
                params.pos_id = $scope.data.currentFilter.id;
                params.loyalty_id = $scope.data.currentFilter.loyalty_id;
            }


            StatisticsService.LoyaltyItemsUsageTerminalSummary(params, function (success, response) {
                if (success) {
                    $scope.data.prepared.loyalty_items_usage_summary = [];
                    $scope.data.prepared.loyalty_items_usage_summary_dynamics_fields = ['item_title', 'item_code', 'item_category', 'item_quantity', 'item_unit', 'loyalty', 'terminal', 'pos'];
                    $scope.data.prepared.loyalty_items_usage_summary = response;
                }
                $scope.blockers.loyalty_items_usage_summary.stop();
            });
        }


        $scope.setLoyaltyItemsSummaryPeriod = function (type) {
            var date_from
            var date_to
            switch (type) {
                case 'today':
                    date_from = moment().subtract(0, 'days').startOf('day').utc().toDate();
                    date_to = moment().subtract(0, 'days').endOf('day').utc().toDate();
                    break;
                case 'yesterday':
                    date_from = moment().subtract(1, 'days').startOf('day').utc().toDate();
                    date_to = moment().subtract(1, 'days').endOf('day').utc().toDate();
                    break;
                case 'week':
                    date_from = moment().weekday(1).utc().toDate();
                    date_to = moment().weekday(7).utc().toDate();
                    break;
                case 'month':
                    date_from = moment().startOf('month').utc().toDate();
                    date_to = moment().endOf('month').utc().toDate();
                    break;
                case 'year':
                    date_from = moment().startOf('year').utc().toDate();
                    date_to = moment().endOf('year').utc().toDate();
                    break;
            }

            $scope.params.loyalty_items_usage_summary.date_from = date_from;
            $scope.params.loyalty_items_usage_summary.date_to = date_to;
            $scope.params.loyalty_items_usage_summary.time_from = moment().startOf('day').utc().toDate();
            $scope.params.loyalty_items_usage_summary.time_to = moment().endOf('day').utc().toDate();

            getLoyaltyItemsUsageTerminalSummary();
        }

        function getUsingApp() {
            // if (!$scope.blockers.bonuses.state().blocking)
            $scope.blockers.using_app.start();

            var params = angular.copy($scope.params.using_app);
            params.loyalty_id = $scope.data.currentLoyalty.id;

            StatisticsService.UsingApp(params, function (success, response) {
                if (success) {
                    if (response && response.all_customers_count) {
                        $scope.data.prepared.using_app = [
                            {
                                field: 'mobileapp_customers_count',
                                value: response.mobileapp_customers_count,
                                d_value: response.mobileapp_customers_count,
                                color: 'rgb(97,181,97)'
                            },
                            {
                                field: 'all_customers_count',
                                value: response.all_customers_count - response.mobileapp_customers_count,
                                d_value: response.all_customers_count,
                                color: 'rgb(225,225,225)'
                            }
                        ];

                        // saveJSONToFile('using_app', $scope.data.prepared.using_app);
                    } else {
                        $scope.data.prepared.using_app = [{field: 'no_data', value: 100, color: 'rgb(225,225,225)'}];
                    }
                }
                $scope.blockers.using_app.stop();
            });
        }

        function _doShow() {
            function s() {
                if ($rootScope.ENV.business.currency && $rootScope.ENV.business.tariff) {
                    if ($rootScope.ENV.settings.hideDemo)
                        $scope.state.showDemo = false;
                    else
                        $scope.state.showDemo = moment().diff(moment($rootScope.ENV.business.created), 'days', true) <= 14;

                    if ($rootScope.ENV.business.tariff.analytics_available) {
                        $rootScope.TARIFF_LIMITATION.analytics_available = false;
                    } else {
                        $rootScope.TARIFF_LIMITATION.analytics_available = true;
                    }

                    $scope.onChangeTab($scope.state.currentTab, true);
                } else {
                    $timeout(s, 250);
                }
            }

            s();
        }

        $scope.onChangeTab = function (tab, update) {
            if (!isPageMode('dashboard')) {
                console.info('onChangeTab', tab);
                initBlockers();

                $scope.state.currentTab = tab;
                $location.url('/').search('tab', tab);

                if ($scope.state.showDemo || $rootScope.TARIFF_LIMITATION.analytics_available) {
                    // if ($scope.state.showDemo) {
                    getDemoData();
                } else {
                    switch (tab) {
                        case 'customers':
                            if (update || !$scope.data.prepared.visits)
                                getVisits();
                            if (update || !$scope.data.prepared.segments_dynamics)
                                getSegmentsDynamics();
                            break;
                        case 'corporate':
                            if (update || !$scope.data.prepared.corporate_visits)
                                getCorporateVisits();
                            if (update || !$scope.data.prepared.corporate_segments_dynamics)
                                getCorporateSegmentsDynamics();
                            break;
                        case 'turnover':
                            if (update || !$scope.data.prepared.turnover)
                                getTurnover();
                            if (update || !$scope.data.prepared.turnover_by_time)
                                getTurnoverByTime();
                            break;
                        case 'visits':
                            if (update || !$scope.data.prepared.bonuses)
                                getBonuses();
                            if (update || !$scope.data.prepared.visits_by_pos)
                                getVisitsByPOS();
                            //getVisitsByTime();
                            break;
                        case 'cost-and-app':
                            if (update || !$scope.data.prepared.redeem_by_pos)
                                getRedeemByPOS();

                            if (update || !$scope.data.prepared.using_app)
                                getUsingApp();
                            // if (update || !$scope.data.prepared.turnover_by_pos)
                            //     getTurnoverByPOS();
                            break;
                        // case 'goods_services':
                        //     if (update || !$scope.data.prepared.loyalty_items_usage_summary)
                        //     getLoyaltyItemsUsageTerminalSummary()
                        //     break;
                    }
                }
            }
        };

        $scope.updateEntity = function (entity) {
            switch (entity) {
                case 'visits':
                    getVisits();
                    break;
                case 'corporate':
                    if ($scope.params.statistics_corporate === 'visits') {
                        getCorporateVisits()
                    }
                    if ($scope.params.statistics_corporate === 'turnover') {
                        getCorporateTurnover()
                    }
                    break;
                case 'turnover':
                    getTurnover();
                    break;
                case 'redeem_by_pos':
                    getRedeemByPOS();
                    break;
                case 'bonuses':
                    getBonuses();
                    break;
                case 'turnover_by_pos':
                    getTurnoverByPOS();
                    break;
                case 'turnover_by_time':
                    getTurnoverByTime();
                    break;
                // case 'visits_by_time':      getVisitsByTime();      break;
                case 'visits_by_pos':
                    getVisitsByPOS();
                    break;
                case 'segments_dynamics':
                    getSegmentsDynamics();
                    break;
                case 'corporate_segments_dynamics':
                    getCorporateSegmentsDynamics();
                    break;
                case 'using_app':
                    getUsingApp();
                    break;
            }
        };

        $scope.getPOSById = function (id) {
            if (id && id.indexOf('demo_') === 0) {
                if (id.indexOf('1') > 0)
                    return 'Super Pizza: margherita';
                if (id.indexOf('2') > 0)
                    return 'Super Pizza: americano';
                if (id.indexOf('3') > 0)
                    return 'Super Pizza: veterano';
                if (id.indexOf('4') > 0)
                    return 'Super Pizza: jamaica';
            }

            if (id === 'total')
                return $filter('translate')('TEXT_POS_TOTAL');

            return itemByIndex($rootScope.POS, id) ? itemByIndex($rootScope.POS, id).title : 'field_no_data';
        };

        $scope.onHideDemo = function () {
            $scope.state.showDemo = false;
            $scope.onChangeTab($scope.state.currentTab, true);

            $rootScope.ENV.settings.hideDemo = true;
            $rootScope.storeENV();
        };

        $scope.toggleSegmentsDynamics = function () {
            if (!$scope.state.hideLostCustomers) {
                $scope.data.prepared.segments_dynamics_saved = angular.copy($scope.data.prepared.segments_dynamics);

                for (var i in $scope.data.prepared.segments_dynamics) {
                    $scope.data.prepared.segments_dynamics[i].customers_lost = 0;
                }
            } else {
                if ($scope.data.prepared.segments_dynamics_saved)
                    $scope.data.prepared.segments_dynamics = angular.copy($scope.data.prepared.segments_dynamics_saved);
            }
        };

        $scope.toggleCorporateSegmentsDynamics = function () {
            if (!$scope.state.hideLostCorporateCustomers) {
                $scope.data.prepared.corporate_segments_dynamics_saved = angular.copy($scope.data.prepared.corporate_segments_dynamics);

                for (var i in $scope.data.prepared.corporate_segments_dynamics) {
                    $scope.data.prepared.corporate_segments_dynamics[i].customers_lost = 0;
                }
            } else {
                if ($scope.data.prepared.corporate_segments_dynamics_saved)
                    $scope.data.prepared.corporate_segments_dynamics = angular.copy($scope.data.prepared.corporate_segments_dynamics_saved);
            }
        };

        $scope.changeCorporateStatistics = function () {
            if ($scope.params.statistics_corporate === 'visits') {
                getCorporateVisits()
            }
            if ($scope.params.statistics_corporate === 'turnover') {
                getCorporateTurnover()
            }
        }

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                var saved_loyalty;

                if ($rootScope.ENV.filters.statistics_list && $rootScope.ENV.filters.statistics_list.loyalty_id)
                    saved_loyalty = itemByIndex($scope.data.loyaltiesList, $rootScope.ENV.filters.statistics_list.loyalty_id);

                if (saved_loyalty && saved_loyalty.active === 1)
                    $scope.data.currentLoyalty = saved_loyalty;
                else
                    $scope.data.currentLoyalty = $scope.data.loyaltiesList[0];

                $scope.blockers.home.stop();
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue && !isPageMode('dashboard')) {
                SelectService.getPOSList(function (success, response) {
                    if (success)
                        for (var i in response) {
                            var index;
                            if (!index && response[i].active === 1 && response[i].loyalty_id === newValue.id)
                                index = i;
                        }

                    delete $scope.params.turnover_by_pos.pos_id;
                    delete $scope.params.turnover_by_time.pos_id;
                    delete $scope.params.redeem_by_pos.pos_id;
                    delete $scope.params.visits_by_pos.pos_id;

                    _doShow();
                });

                $rootScope.ENV.filters.statistics_list = {
                    loyalty_id: newValue.id
                };
                $rootScope.storeENV();
            }
        }, true);

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.LPR_LIST);

                $scope.data.filtersList.unshift({
                    title: $filter('translate')('All loyalties'),
                    id: '0',
                    active: 1,
                    filter_list_type: 'all'
                });

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {

                        if ($rootScope.ENV.filters.global_filter.id) {
                            if (filterItem.filter_list_type === 'register' && filterItem.id === $rootScope.ENV.filters.global_filter.id) {
                                return true;
                            }
                        } else if ($rootScope.ENV.filters.global_filter.pos_id) {
                            if (filterItem.filter_list_type === 'pos' && filterItem.id === $rootScope.ENV.filters.global_filter.pos_id) {
                                return true;
                            }
                        } else if ($rootScope.ENV.filters.global_filter.loyalty_id) {
                            if (filterItem.filter_list_type === 'loyalty' && filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                return true;
                            }
                        }
                    });
                    if (!$scope.data.currentFilter) {
                        for (var i in $scope.data.filtersList)
                            if ($scope.data.filtersList[i].id === '0')
                                $scope.data.currentFilter = $scope.data.filtersList[i];
                    }
                } else {
                    if ($scope.data.filtersList) {
                        for (var i in $scope.data.filtersList)
                            if ($scope.data.filtersList[i].id === '0')
                                $scope.data.currentFilter = $scope.data.filtersList[i];
                    }
                }
            }

        });

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {
            if (newValue) {
                $rootScope.ENV.filters.registers_list = {
                    filter: newValue
                };

                if (newValue.filter_list_type === 'loyalty') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                } else if (newValue.filter_list_type === 'pos' || newValue.filter_list_type === 'register') {
                    $rootScope.ENV.filters.global_filter = {
                        loyalty_id: newValue.loyalty_id || null,
                        pos_id: newValue.filter_list_type === 'pos' ? newValue.id : newValue.pos_id || null,
                        id: newValue.filter_list_type === 'register' ? newValue.id : null,
                    };
                } else if (newValue.id === '0') {
                    $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                }

                $rootScope.storeENV();
            }
        }, true);


        $scope.searchByCustomer = function () {
            if ($scope.priceTab == 'search-by-commercial') {
                $scope.params.commercial_customer_id = '';
                var params = {
                    email: $scope.params.commercial_customer_email
                }
                CorporateCustomerService.All(params, function (success, response) {
                    if (!success) {
                        return
                    }
                    if (response.data.length == 0) {
                        return
                    }
                    $scope.params.commercial_customer_id = response.data[0].id;
                    getTerminals()
                });
            }
            if ($scope.priceTab == 'search-by-customer') {
                getTerminals()
            }
        }
    }
})();
